import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Equation } from "@/components/home/Equation";
import { Bento } from "@/components/home/Bento";
import { LeaseSplit } from "@/components/home/LeaseSplit";
import { PhotoBand } from "@/components/home/PhotoBand";
import { FounderNote } from "@/components/home/FounderNote";
import { CtaBand } from "@/components/site/CtaBand";
import { Testimonials } from "@/components/site/Testimonials";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Equation />
      <Bento />
      <Testimonials />
      <LeaseSplit />
      <PhotoBand />
      <FounderNote />
      <CtaBand />
    </div>
  );
}
